export default function HashEmitter() {
  window.addEventListener("hashchange", function () {
    Channels.emit("window::hashchange");
  });
}
